import { useTranslation } from 'react-i18next';

function Technology() {
  const { t } = useTranslation();
  const technologies = t('technology.items', { returnObjects: true });

  return (
    <section id="technology" className="section technology-section">
      <div className="technology-panel">
        <div className="technology-intro">
          <div className="eyebrow">{t('technology.eyebrow')}</div>
          <h2>{t('technology.title')}</h2>
          <p>{t('technology.description')}</p>

          <div className="architecture-note">
            <strong>{t('technology.noteTitle')}</strong>
            <span>{t('technology.noteText')}</span>
          </div>
        </div>

        <div className="tech-list">
          {technologies.map((technology) => (
            <div className={`tech-item ${technology.className}`} key={technology.name}>
              <span>{technology.name}</span>
              <p>{technology.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Technology;
